import React, { useRef } from 'react';
import { Box, Typography, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '../../../../components/modals/Modal';
import { EditableTable, EditableTableRef } from './EditableTable';
import { EditableTableProvider, useEditableTableContext } from './Context/EditableTableContext';
import { GenericTableModalProps, BaseTableRow } from './types';
import { AddBox } from '@mui/icons-material';

function AddNewLineButton({ onClick }: { onClick: () => void }): React.ReactElement {
  const { editingRowId, isAddingNewRow } = useEditableTableContext();
  const disabled = editingRowId !== null || isAddingNewRow;
  return (
    <Button
      variant="outlined"
      disableRipple
      disableElevation
      size="small"
      onClick={onClick}
      disabled={disabled}
      startIcon={<AddBox />}
      sx={{ fontSize: '12px' }}
    >
      Add New Line
    </Button>
  );
}

export function GenericTableModal<T extends BaseTableRow>({
  open,
  onClose,
  title = 'Table Management',
  sx,
  headers,
  data,
  onAction,
  EditableComponent,
  onScroll,
  type,
}: GenericTableModalProps<T>): React.ReactElement {
  const editableTableRef = useRef<EditableTableRef>(null);
  console.log({ EditableComponent });
  const handleClose = () => {
    onClose();
  };

  const handleAddNewRow = () => {
    console.log('handleAddNewRow called from CreateGenericModal');
    console.log('editableTableRef.current:', editableTableRef.current);
    editableTableRef.current?.addNewRow();
  };

  return (
    <EditableTableProvider>
      <Modal
        open={open}
        onClose={handleClose}
      sx={{
        '& > .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        '& > .MuiBox-root': {
          // Fixed height so header stays visible when table scrolls
          height: 'calc(100dvh - 76px) !important',
          maxHeight: 'calc(100dvh - 76px) !important',
          top: '50% !important',
          left: '50% !important',
          transform: 'translate(-50%, -50%) !important',
          borderRadius: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          ...(sx || {}),
        },
      }}
    >
      <Modal.Header>
        <Box
          sx={{
            backgroundColor: 'primary.main',
            padding: '3px 15px',
            display: 'flex',
            flexDirection: 'row',
            position: 'sticky',
            top: 0,
            zIndex: 2,
            alignItems: 'center',
            flexShrink: 0,
          }}
        >
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography
              sx={{
                color: '#fff',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}
            >
              {title}
            </Typography>
          </Box>
          <IconButton aria-label="close" onClick={handleClose} sx={{ color: '#fff' }}>
            <CloseIcon sx={{ color: '#fff' }} />
          </IconButton>
        </Box>
      </Modal.Header>

      <Modal.Body>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            backgroundColor: 'background.paper',
            overflow: 'hidden',
            height: '100%',
            padding: '0px',
          }}
        >
          <EditableTable
            ref={editableTableRef}
            headers={headers}
            data={data}
            onAction={onAction}
            EditableComponent={EditableComponent}
            onScroll={onScroll}
            modalOpen={open}
            type={type}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            p: 1,
            width: '100%',
            flexShrink: 0,
            backgroundColor: 'background.paper',
            borderTop: '1px solid',
            borderColor: 'divider',
            boxSizing: 'border-box',
            overflow: 'visible',
          }}
        >
          <AddNewLineButton onClick={handleAddNewRow} />
        </Box>
      </Modal.Footer>
    </Modal>
    </EditableTableProvider>
  );
}
